import React from 'react';
export function FinalCTA() {
  return <div className="bg-blue-600 text-white py-12 px-4" data-id="element-39">
      <div className="max-w-3xl mx-auto text-center" data-id="element-40">
        <h2 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-41">
          Ready to Support Your Dog's Dental Health?
        </h2>
        <p className="text-lg mb-6" data-id="element-42">
          Join thousands who have discovered Melao™ Dental Formula
        </p>
        <a href="https://hushpups.co/products/melao-dental-formula" className="inline-block bg-white text-blue-600 hover:bg-gray-100 font-bold py-4 px-8 rounded-lg text-xl transition-colors duration-300" data-id="element-43">
          CLAIM YOUR OFFER NOW →
        </a>
        <p className="text-sm mt-4 opacity-90" data-id="element-44">
          30-Day Money-Back Guarantee • Safe for Dogs & Cats
        </p>
        <p className="text-xs mt-8 opacity-75 max-w-2xl mx-auto" data-id="element-45">
          These statements have not been evaluated by the Food and Drug
          Administration. This product is not intended to diagnose, treat, cure,
          or prevent any disease.
        </p>
      </div>
    </div>;
}